import { useState } from "react";
import "./EditCommandModal.css";
import { CommandsQueries } from "../../../../requests/queries/CommandsQueries";

const STATUS_LABELS = {
    created: "Créé",
    paid: "Payée",
    preparing: "En préparation",
    ready: "Prête à récupérer",
    delivered: "Livré",
    cancelled: "Annulé",
    payment_cancelled: "Paiement annulé",
    payment_failed: "Paiement échoué",
};

function StatusBadge({ status }) {
    const label = STATUS_LABELS[status] || status;
    return (
        <span className={`command-status-badge status-${status}`}>
            {label}
        </span>
    );
}

export default function EditCommandModal({ command, fetchCommands }) {
    const [isOpen, setIsOpen] = useState(false);
    const [commandStatus, setCommandStatus] = useState(command.status);

    const handleSubmit = async (e) => {
        e.preventDefault();
        await CommandsQueries.updateStatus(command.id, commandStatus);
        fetchCommands();
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            setIsOpen(false);
        }
    };

    const productsPreview = command?.products?.map((p) => {
        const name = p.name ?? p.product?.name ?? 'Produit';
        return p.quantity > 1 ? `${name} ×${p.quantity}` : name;
    }).join(", ") || "—";
    const formattedTotal = typeof command.total === "number"
        ? `${command.total.toFixed(2)} €`
        : command.total;

    return (
        <div className="edit-command">
            <article className="edit-command-card" onClick={() => setIsOpen(true)}>
                <div className="edit-command-card-main">
                    <div className="edit-command-card-top">
                        <p className="edit-command-order">
                            Commande <span>#{command.order}</span>
                        </p>
                        <StatusBadge status={command.status} />
                    </div>
                    <p className="edit-command-products-preview">{productsPreview}</p>
                </div>
                <div className="edit-command-card-right">
                    <span className="edit-command-total-preview">{formattedTotal}</span>
                    <span className="edit-command-open-btn">✏️ Modifier</span>
                </div>
            </article>

            {isOpen && (
                <div className="edit-command-overlay" onClick={handleOverlayClick}>
                    <div className="edit-command-modal" role="dialog" aria-labelledby="edit-command-title">
                        <header className="edit-command-modal-header">
                            <div className="edit-command-modal-title-group">
                                <h2 id="edit-command-title">Modifier la commande</h2>
                                <p className="edit-command-modal-subtitle">
                                    Commande #{command.order}
                                </p>
                            </div>
                            <button
                                type="button"
                                className="edit-command-close"
                                onClick={() => setIsOpen(false)}
                                aria-label="Fermer"
                            >
                                ✕
                            </button>
                        </header>

                        <div className="edit-command-modal-body">
                            <div className="edit-command-field">
                                <span className="edit-command-field-label">Numéro</span>
                                <span className="edit-command-field-value order-number">
                                    #{command.order}
                                </span>
                            </div>

                            <div className="edit-command-status-section">
                                <div className="edit-command-status-current">
                                    <span className="edit-command-status-current-label">Statut actuel</span>
                                    <StatusBadge status={command.status} />
                                </div>
                                <form className="edit-command-status-form" onSubmit={handleSubmit}>
                                    <select
                                        value={commandStatus}
                                        onChange={(e) => setCommandStatus(e.target.value)}
                                        className="command-status-select"
                                    >
                                        {Object.entries(STATUS_LABELS).map(([value, label]) => (
                                            <option key={value} value={value}>{label}</option>
                                        ))}
                                    </select>
                                    <button type="submit" className="edit-command-submit-btn">
                                        Enregistrer
                                    </button>
                                </form>
                            </div>

                            <div className="edit-command-field">
                                <span className="edit-command-field-label">Produits</span>
                                <div className="edit-command-products-list">
                                    {command?.products?.length > 0 ? (
                                        command.products.map((line, i) => (
                                            <span key={i} className="edit-command-product-tag">
                                                {line.name ?? line.product?.name ?? 'Produit'}
                                                {line.quantity > 1 ? ` ×${line.quantity}` : ''}
                                            </span>
                                        ))
                                    ) : (
                                        <span className="edit-command-field-value">—</span>
                                    )}
                                </div>
                            </div>

                            <div className="edit-command-field">
                                <span className="edit-command-field-label">Utilisateur</span>
                                <div className="edit-command-user-datas">
                                    {Object.entries(command.user_datas || {}).map(([key, value]) => (
                                        <div key={key} className="edit-command-user-row">
                                            <span className="edit-command-user-key">{key}</span>
                                            <span className="edit-command-user-value">{value}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="edit-command-field">
                                <span className="edit-command-field-label">Total</span>
                                <span className="edit-command-field-value total-amount">
                                    {formattedTotal}
                                </span>
                            </div>
                        </div>

                        <footer className="edit-command-modal-footer">
                            <button
                                type="button"
                                className="edit-command-cancel-btn"
                                onClick={() => setIsOpen(false)}
                            >
                                Fermer
                            </button>
                        </footer>
                    </div>
                </div>
            )}
        </div>
    );
}
